import { render, staticRenderFns } from "./ShowMoreText.vue?vue&type=template&id=a314320e&scoped=true&"
import script from "./ShowMoreText.vue?vue&type=script&lang=js&"
export * from "./ShowMoreText.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreText.vue?vue&type=style&index=0&id=a314320e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a314320e",
  null
  
)

export default component.exports